import React from 'react'
import { createRoot } from "react-dom/client"
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom"
import { ThemeProvider as MaterialThemeProvider } from '@material-ui/core/styles'
import { PersistGate } from 'redux-persist/integration/react'
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { customTheme } from './styling'
import './index.css'

// Components
import Login from './pages/auth/login'
import NotFound from './404'
import Home from './pages/home'
import Chat from './pages/chat'
import Translator from './pages/translator'
import VideoMaker from './pages/video-maker'
import LiveTranslator from './pages/live-translator'
import Audio from './pages/audio'
import Images from './pages/images'
import PrivateRoute from './components/private-route'
import SnackBar from './components/snackbar'
import { persistor, rootStore } from './redux/store'

import { Provider } from 'react-redux'
import DownloadListenerTranslatorAI from './pages/download-listener-translator-ai'

const rootElement = document.getElementById("root")
const root = createRoot(rootElement)

root.render(
  <Provider store={rootStore}>
    <PersistGate loading={null} persistor={persistor}>
      <MaterialThemeProvider theme={customTheme}>
        <SnackBar.Provider>
          <BrowserRouter>
            <Switch>
              <Route exact path='/' render={() => <Redirect to='/home' />} />
              {/* PUBLIC ROUTE */}
              <Route exact path="/login" component={Login} />
              <Route exact path="/home" component={PrivateRoute(Home)} />
              <Route exact path="/chat" component={PrivateRoute(Chat)} />
              <Route exact path="/translator" component={PrivateRoute(Translator)} />
              <Route exact path="/audio" component={PrivateRoute(Audio)} />
              <Route exact path="/images" component={PrivateRoute(Images)} />
              <Route
                exact
                path={[
                  "/video-maker",
                  "/video-maker/:projectId",
                  "/video-maker/:projectId/edit"
                ]}
                component={PrivateRoute(VideoMaker)}
              />
              <Route exact path="/live-translator" component={PrivateRoute(LiveTranslator)} />       
              <Route exact path="/download-listener-translator-ai" component={PrivateRoute(DownloadListenerTranslatorAI)} />        
              <Route component={PrivateRoute(NotFound)} />

            </Switch>
          </BrowserRouter>
        </SnackBar.Provider>
      </MaterialThemeProvider>
    </PersistGate>
  </Provider>

)

